import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserStore } from '../../../services/stores/user.store';
import { UserModel } from '../../../models/user/user.model';
import { DashboardHelper } from '../../../services/dashboard.service';
import { UserService } from '../../../services/user.service';
import * as AppConstants from '../../../modules/catch-core/data/constants/app.constants';

@Component({
  selector: 'app-userprofile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
  standalone: false,
})
export class UserProfileComponent implements OnInit {
  userForm: FormGroup = new FormGroup({});
  currentUser: any;

  constructor(
    private user2Store: UserStore,
    public dashboardHelper: DashboardHelper,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.createForm();

    this.currentUser = this.userService.user;
    this.userForm.setValue({
      firstName: this.currentUser['firstName'],
      lastName: this.currentUser['lastName'],
      emailAddress: this.currentUser['emailAddress'],
    });
  }

  createForm() {
    this.userForm = this.fb.group({
      firstName: '',
      lastName: '',
      emailAddress: '',
    });
  }

  save() {
    const saveUser = this.prepareSaveUser();
    this.user2Store.$updateUser(saveUser).subscribe((success) => {
      if (success) {
        this.userForm.markAsPristine();
        this.applySavedNamesToCurrentUser(saveUser);
        this.dashboardHelper.setShowRightPanel(false);
        this.dashboardHelper.setExpandRightPanel(false);
        this.cdr.detectChanges();
      }
    });
  }

  /**
   * Only the names are editable here, so patch them onto the live user rather than swapping in the payload.
   * The payload is a partial rebuild of the user - notably it carries no `permissions` - and installing it
   * as the current user blanks every PermissionService check for the rest of the session: the project list
   * filters itself down to nothing, the admin nav disappears and Create new project greys out.
   */
  private applySavedNamesToCurrentUser(saveUser: UserModel) {
    const user = this.userService.user;
    if (!user) {
      return;
    }

    user.firstName = saveUser.firstName;
    user.lastName = saveUser.lastName;
    user.displayName = saveUser.displayName;
    this.currentUser = user;
  }

  prepareSaveUser(): UserModel {
    const formModel = this.userForm.value;
    const saveUser: UserModel = new UserModel({
      id: this.currentUser.id,
      organizationId: this.userService.user?.organizationId,
      description: this.currentUser.description,
      directoryId: this.currentUser.directoryId,
      userName: this.currentUser.userName,
      groups: this.currentUser.groups,
      isActive: this.currentUser.isActive,
      firstName: formModel.firstName,
      lastName: formModel.lastName,
      // The server recomputes this from the names; keep the local copy in step so the header does not
      // keep showing the old name until the next reload.
      displayName: `${formModel.firstName} ${formModel.lastName}`,
      emailAddress: this.currentUser.emailAddress,
      credential: AppConstants.USERPASSWORDNOTSET,
      isArchived: this.currentUser.isArchived,
      // Neither of these is editable here, but UserModel defaults them to 0 / false and the API PATCH
      // writes any non-null value it receives - so they have to be carried through or the save silently
      // resets the user's T&C acceptance (re-prompting on the next login) and clears their ET flag.
      acceptedTerms: this.currentUser.acceptedTerms,
      isInET: this.currentUser.isInET,
    });

    return saveUser;
  }
}
